<template>
  <div class="container">
    <Stars />
    <div class="header">
      <div class="info">
        <img src="../../image/home-avatar.png" alt="" />
        <p>中国农业博物馆</p>
        <!-- <p>
          中国农业博物馆和全国农业展览馆是两块牌子、一个机构，为中华人民共和国农业农村部直属事业单位
        </p> -->
      </div>
    </div>
    <div class="content">
      <div class="content-header">
        <div class="max-h">
          <div class="menus" ref="menus">
            <div
              v-for="(type, index) in types"
              :key="index"
              class="menu"
              :class="{ active: type.class_id == active }"
              @click="handleChange(type.class_id)"
            >
              {{ type.className }}
            </div>
          </div>
          <div class="query">
            <input type="text" placeholder="关键字" v-model="query" />
            <div class="search" @click="handleClose">
              <img
                :src="
                  query
                    ? require('../../image/close.png')
                    : require('../../image/search.png')
                "
                alt=""
              />
            </div>
          </div>
          <img
            @click="handleScroll(true)"
            class="arrow left"
            src="../../image/arrow-left.png"
            alt=""
            v-show="showLeft"
          />
          <img
            @click="handleScroll(false)"
            class="arrow right"
            src="../../image/arrow-right.png"
            alt=""
            v-show="showRight"
          />
        </div>
        <div
          class="query-m"
          :class="{ 'active-q': isSearch }"
          @click="isSearch = !isSearch"
        >
          <img
            :src="
              isSearch
                ? require('../../image/search-w.png')
                : require('../../image/search.png')
            "
            alt=""
          />
        </div>
      </div>
      <div class="input-m" :class="{ 'show-m': isSearch }">
        <div class="search" @click="handleClose">
          <input type="text" placeholder="关键字" v-model="query" />
          <img
            :src="
              query
                ? require('../../image/close.png')
                : require('../../image/search.png')
            "
            alt=""
          />
        </div>
      </div>
      <div class="list">
        <div class="work" v-for="work in works" :key="work.id">
          <div class="info">
            <div class="cover">
              <img :src="work.modLogo" alt="" />
            </div>
            <div class="name">
              <span>{{ work.modName }}</span>
              <div class="operate">
                <div class="operate-item">
                  <img src="../../image/view.png" alt="" /> {{work.viewCount}}
                </div>
                <!-- <div class="operate-item">
                  <img src="../../image/like.png" alt="" /> {{work.likeCount}}
                </div> -->
              </div>
            </div>
            <router-link
              class="look"
              target="_blank"
              :to="{ path: '/ARPage', query: { id: work.mid } }"
            >
              <div class="scroll"></div>
              <div class="show">点击查看</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Stars from "./stars.vue";

export default {
  name: "",
  components: { Stars },
  props: [],
  data() {
    return {
      active: 0,
      types: [],
      works: [],
      query: "",
      isSearch: false,
      showLeft: false,
      showRight: true,
      timer: null,
    };
  },
  watch: {
    query() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getModels();
      }, 500);
    },
  },
  computed: {},
  created() {},
  mounted() {
    this.getTypes();
    this.getModels();
  },
  methods: {
    handleChange(id) {
      this.active = id;
      this.getModels();
    },
    getModels() {
      this.$http
        .get("https://nybwg.11dom.com/h5/model_list", {
          params: {
            cid: 10,
            class_fid: this.active,
            per_page: 40,
            modName: this.query,
          },
        })
        .then((res) => {
          const { data } = res.data.data;
          this.works = data;
        });
    },
    getTypes() {
      this.$http
        .get("https://nybwg.11dom.com/h5/model_list/classes", {
          params: { cid: 10, pc: 1 },
        })
        .then((res) => {
          const types = [{ class_id: 0, className: "全部" }];
          const { data } = res.data;
          data.forEach((v) => types.push(v));
          this.types = types;
        });
    },
    handleScroll(b) {
      let menus = this.$refs.menus;
      let width = menus.getBoundingClientRect().width;
      let scrollWidth = menus.scrollWidth;
      if (b) {
        if (menus.scrollLeft > 0) {
          menus.scrollLeft -= width;
          this.showRight = true;
        } else {
          this.showLeft = false;
        }
      } else {
        if (menus.scrollLeft + width < scrollWidth) {
          menus.scrollLeft += width;
          this.showLeft = true;
        } else {
          this.showRight = false;
        }
      }
    },
    handleClose() {
      if (this.query) {
        this.query = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  width: 100%;
  min-height: 100vh;
  color: #fff;
  background: radial-gradient(circle, #070403 0, #282828 100%);
  .header {
    width: 100%;
    height: 350px;
    background-image: url("../../image/home-header.jpg");
    background-size: 100% 100%;
    .info {
      width: 100%;
      height: 100%;
      padding: 0 1em;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }
      p {
        color: #ccc;
        text-align: center;
        &:nth-child(2) {
          color: #fff;
          margin-top: 25px;
          font-size: 18px;
        }
      }
    }
  }
  .content {
    &-header {
      width: 100%;
      background: rgba(99, 96, 90, 0.3);
      color: #ccc;
      padding: 9px 0;
      line-height: 30px;
      .max-h {
        max-width: 1179px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .menus {
          display: flex;
          width: calc(75% - 40px);
          overflow-y: scroll;
          .menu {
            display: flex;
            flex-shrink: 0;
            padding: 0 20px;
            line-height: 32px;
            cursor: pointer;
            transition: all 0.3s;
            &:hover {
              color: #d5b484;
            }
          }
          .active {
            color: #d5b484;
          }
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .query {
          width: 25%;
          position: relative;
          .search {
            position: absolute;
            top: 0;
            right: 5px;
            line-height: 33px;
            cursor: pointer;
            img {
              width: 16px;
            }
          }
        }
        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
        .left {
          left: -20px;
        }
        .right {
          right: calc(25% + 5px);
        }
      }
      .query-m {
        display: none;
      }
    }
    .list {
      max-width: 1179px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      padding-top: 1.5em;
      .work {
        width: 20%;
        .info {
          padding: 0 7.5px;
          margin-bottom: 1em;
          display: flex;
          flex-direction: column;
          color: #d5b484;
          position: relative;
          .look {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(100% - 40px);
            background-color: rgba(0, 0, 0, 0.3);
            padding: 0 7.5px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-decoration: none;
            visibility: hidden;
            cursor: pointer;
            .scroll {
              border: 2px dashed #fff;
              width: 92px;
              height: 92px;
              position: absolute;
              border-radius: 50%;
              animation: rotate 15s linear 0s infinite;
            }
            .show {
              width: 76px;
              height: 76px;
              line-height: 76px;
              border-radius: 50%;
              text-align: center;
              color: #fff;
              background: hsla(0, 0%, 100%, 0.3);
            }
          }
          .cover {
            width: 100%;
            height: 0;
            overflow: hidden;
            padding-bottom: 100%;
            position: relative;
            &::before {
              content: "";
              position: absolute;
              width: 100%;
              height: 3px;
              bottom: 0;
              left: 0;
              background-color: #df8839;
              visibility: hidden;
              -webkit-transform: scaleX(0);
              transform: scaleX(0);
              -webkit-transition: all 0.6s ease-in-out 0s;
              transition: all 0.6s ease-in-out 0s;
              top: 0;
              z-index: 1;
            }
            img {
              width: 100%;
              transition: all 2s;
            }
          }
          .name {
            background: rgba(89, 89, 88, 0.6);
            padding: 0 0.5em;
            font-size: 12px;
            letter-spacing: 1.2px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            span {
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
            .operate {
              display: flex;
              align-items: center;
              &-item {
                display: flex;
                align-items: center;
                margin-left: 10px;
                img {
                  width: 16px;
                  margin-right: 10px;
                }
              }
            }
          }
        }
      }
      .work:hover {
        .cover::before {
          visibility: visible;
          transform: scaleX(1);
        }
        .look {
          visibility: visible;
        }
        .cover img {
          transform: scale(1.3);
        }
      }
    }
    input {
      background: #1f1e1e;
      border-radius: 5px;
      color: #d5b484;
      display: inline-block;
      width: 100%;
      height: 32px;
      line-height: 1.5;
      padding: 4px 7px;
      padding-right: 32px;
      font-size: 12px;
      border: 1px solid transparent;
      &:focus {
        border-color: #e5a061;
        box-shadow: 0 0 0 2px rgb(223 136 57 / 20%);
      }
    }
    input[type="text"]:not(:disabled),
    input:not(:disabled) {
      outline: none;
    }
    .input-m {
      height: 0;
      overflow: hidden;
      transition: all 0.3s;
      .search {
        position: relative;
        padding: 0 20px;
        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 16px;
          right: 30px;
          line-height: 32px;
        }
      }
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 1480px) {
  .container .content .list .work {
    width: 25%;
  }
}
@media (max-width: 800px) {
  .container {
    .header {
      // background-size: 200% 100%;
      background: url(../../image/home-header.jpg) 50% center;
    }
    .content {
      &-header {
        position: relative;
        .max-h {
          .menus {
            width: 100%;
            padding-right: 50px;
          }
          .query {
            display: none;
          }
        }
        .query-m {
          position: absolute;
          top: 0;
          right: 0;
          width: 50px;
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba(0, 0, 0, 0.8);
          color: silver;
          img {
            width: 16px;
          }
        }
        .active-q {
          background-color: rgba(182, 133, 64, 0.8);
        }
      }
      .list {
        .work {
          width: 33.33%;
        }
      }
      .show-m {
        padding-top: 20px;
        height: 52px;
      }
    }
  }
  .container .content-header .max-h .arrow {
    display: none;
  }
}

@media (max-width: 600px) {
  .container .content .list .work {
    width: 50%;
  }
}

@media (max-width: 300px) {
  .container .content .list .work {
    width: 100%;
  }
}
</style>